import React from 'react'

function Footer() {
   return (
      <div className='footer_section wow animate__fadeInUp' data-wow-duration="1s">
         <div className='footer_container'>
            <div className='footer_content'>
               <div className='footer_menu_main_content'>

                  <div className='footer_menu_left_content'>
                     <div className='title_footer_menu'> Quick Links</div>
                     <div className='footer_menu_links'>
                        <ul className='footer_ul_list'>
                           <li className='footer_item'>
                              <a className='footer_link' href="/">Home</a>
                           </li>
                           <li className='footer_item'>
                              <a className='footer_link' href="/about">About Us</a>
                           </li>
                           <li className='footer_item'>
                              <a className='footer_link' href="/portfolio">Portfolio</a>
                           </li>
                           <li className='footer_item'>
                              <a className='footer_link' href="/blog">Blog</a>
                           </li>
                           <li className='footer_item'>
                              <a className='footer_link' href="/?section=middle">FAQs</a>
                           </li>
                           <li className='footer_item'>
                              <a className='footer_link' href="/contact">Contact Us</a>
                           </li>
                        </ul>
                     </div>
                  </div>
                  <div className='footer_menu_left_content'>
                     <div className='footer_menu_legalpages'>
                        <div className='title_footer_menu'>Legal Pages</div>
                        <div className='footer_menu_links'>
                           <ul className='footer_ul_list'>
                              <li className='footer_item'>
                                 <a className='footer_link' href="/termofuse">Term of Use</a>
                              </li>
                              <li className='footer_item'>
                                 <a className='footer_link' href="/privacypolicy">Privacy Policy</a>
                              </li>
                              <li className='footer_item'>
                                 <a className='footer_link' href="/cookiepolicy">Cookie Policy</a>
                              </li>
                              <li className='footer_item'>
                                 <a className='footer_link' href="/disclaimer">Disclaimer</a>
                              </li>
                           </ul>
                        </div>

                     </div>
                  </div>
               </div>
               <div className='footer_newsletter_content'>
                  <p className='newsletter'>
                     We collaborate with ambitious founders to create brands and products people really enjoy.
                     <br />
                     <br />
                     <strong className='footer_strong_text'>Email: </strong>
                     <a className='text-link' href="mailto:info@netaesthetics.com">info@netaesthetics.com</a>
                     <br />
                     <strong className='footer_strong_text'>Phone: </strong>
                     <a className='text-link' href="tel:+12026008034">+1 (202) 600-8034</a>
                     <br />
                     <strong className='footer_strong_text'>Address: </strong>
                     <a className='text-link' href="https://goo.gl/maps/ej1KjSSrvvMsVwRs8"> 2001 L St NW Suite 500, Washington, DC 20036</a>
                  </p>
                  <div className='title_footer_menu'>Subscribe to our newsletter</div>
                  <div className='contact_social_media'>
                     <h3 className='followustitle'>Follow Us</h3>
                     <div className='contact_social_media_links'>
                        <a className='social_media_link' target='_blank' href="https://www.facebook.com/NetAesthetics/">
                           <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d11507f77e9ffbee3b49d3_NetAetshetics%20Social%20Icon%20-%20Facebook.svg" alt="" />
                        </a>
                        <a className='social_media_link' target='_blank' href="https://www.instagram.com/netaesthetics/">
                           <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d1150862b7fa02c26b07b0_NetAetshetics%20Social%20Icon%20-%20Instagram.svg" alt="" />
                        </a>
                        <a className='social_media_link' target='_blank' href="https://www.linkedin.com/company/netaesthetics/">
                           <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d115079c5e182becc9024a_NetAetshetics%20Social%20Icon%20-%20LinkedIn.svg" alt="" />
                        </a>
                        <a className='social_media_link' target='_blank' href="https://www.upwork.com/ag/netaesthetics/">
                           <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d11508550a566ce87de603_NetAetshetics%20Social%20Icon%20-%20UpWork.svg" alt="" />
                        </a>
                        <a className='social_media_link' target='_blank' href="https://www.crunchbase.com/organization/netaesthetics">
                           <img src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/63d11507b378db2d3e116613_NetAetshetics%20Social%20Icon%20-%20Crunchbase.svg" alt="" />
                        </a>

                     </div>
                  </div>
               </div>
            </div>
            <div className='footer_content_bottom'>
               <a className='footer_logo_container' href="/">
                  <img className='footer_logo_image' src="https://cdn.prod.website-files.com/61962f94f13cb64145c209c3/61c46b15451a6a874a4ae838_NetAesthetics%20Logo.svg" alt="" />
               </a>
               <div className='copyright_container'>
                  Copyright
                  <span className='copyright_year'> 2024 </span>
                  Veracity Holdings, Inc. dba
                  <strong className='footer_strong_text'> NetAesthetics </strong>
                  | All Rights Reserved
               </div>
            </div>
         </div>
      </div>
   )
}

export default Footer